import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { adminApi, errorText } from "./adminApi";

export const PasswordDialog = ({ open, onOpenChange }) => {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await adminApi.changePassword(cur, next);
      toast.success("Password updated");
      setCur(""); setNext("");
      onOpenChange(false);
    } catch (ex) {
      toast.error(errorText(ex));
    }
  };
  const cls = "mt-1.5 w-full rounded-xl bg-white/5 border border-white/10 px-4 py-3 text-sm text-white focus:outline-none focus:border-[#FF2A8D]";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0E1326] border-white/10 text-white sm:max-w-sm rounded-3xl">
        <DialogHeader><DialogTitle className="font-display text-2xl">Change password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <label className="block text-xs text-slate-400">Current password
            <input data-testid="pw-current" type="password" required value={cur} onChange={(e) => setCur(e.target.value)} className={cls} />
          </label>
          <label className="block text-xs text-slate-400">New password (8+ characters)
            <input data-testid="pw-new" type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)} className={cls} />
          </label>
          <button data-testid="pw-submit" className="w-full rounded-full bg-[#FF2A8D] hover:bg-[#FF54A5] py-3 font-semibold transition-colors">Save</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
